import { MenuOutlined } from '@ant-design/icons';
import { Link } from '@reach/router';
import { Breadcrumb, Button, Col, Dropdown, Menu, Row, Typography as T } from 'antd';
import { ClickParam } from 'antd/lib/menu';
import { navigate } from 'gatsby';
import React from 'react';
import { localizedSlug } from '../../gatsby/NodeHelpers';
import Tags, { TagListMap } from '../Tags';
import i18n from './i18n';
import './index.scss';

type IType = 'blog' | 'shop'

interface IMenuCategoryProps {
  locale: string
  tags?: string[]
  title?: string
  type: IType
}

const CategoryList = (locale: string, type: IType) => {
  const onMenuClick = (param: ClickParam) => {
    navigate(localizedSlug({ lang: locale, uid: `${type}/tags/${param.key}` }))
  }
  return (
    <Menu onClick={onMenuClick} mode="vertical" className="sg-list-product">
      {TagListMap(locale).map((tagItem, index: number) => (
        <Menu.Item key={tagItem.key}>{tagItem.text}</Menu.Item>
      ))}
    </Menu>
  )
}

const MenuCategory = ({ locale, tags, title, type }: IMenuCategoryProps) => (
  <Row gutter={[8, 20]} align="middle" justify="start">
    <Col flex="0 1 auto">
      <Dropdown overlay={CategoryList(locale, type)} trigger={['click']}>
        <Button>
          <MenuOutlined />{' '}
          <T.Text>{type === 'blog' ? i18n[locale].blogCategory : i18n[locale].productCategory}</T.Text>
        </Button>
      </Dropdown>
    </Col>
    <Col flex="auto">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={localizedSlug({ lang: locale, uid: `` })}>{i18n[locale].home}</Link>
        </Breadcrumb.Item>
        {tags && (
          <Breadcrumb.Item>
            <Link to={type === 'blog' ? localizedSlug({ lang: locale, uid: `blog` }) : localizedSlug({ lang: locale, uid: `shop` })}>
              <T.Text>{type === 'blog' ? i18n[locale].blog : i18n[locale].shop}</T.Text>
            </Link>
          </Breadcrumb.Item>
        )}
        {tags && (
          <Breadcrumb.Item>
            <Tags type={type} tags={tags} locale={locale} className="sg-tag-breadcrumb" />
          </Breadcrumb.Item>
        )}
        {title && <Breadcrumb.Item>{title}</Breadcrumb.Item>}
      </Breadcrumb>
    </Col>
  </Row>
)

export default MenuCategory
